module.exports = __webpack_public_path__ + "media/images/icons/top-e7b034a8f55b2471daaac2fbfe6bac84.svg";